import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <div className="text-center" data-id="element-18" data-mp="avd0itzoq0d6">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-19" data-mp="aua4k7ni97qe">
            Solo per oggi
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-20" data-mp="frtkdbzupskg">
            <span aria-hidden="true" data-id="element-21" data-mp="5wi4gqcpifb4">🎁 </span>Ricevi i 5 Bonus Strategici{' '}
            <span className="italic text-grape" data-id="element-22" data-mp="3o1le8odmbfhv">«Salva-Docente»</span>
          </h2>
          <p className="mt-3 text-sm text-navy/60" data-id="element-23" data-mp="3o3pu84osk4yi">
            Valore totale:{' '}
            <span className="font-bold text-navy/40 line-through" data-id="element-24" data-mp="3t0ycs6duqb0a">€76</span> —
            Inclusi a <span className="font-bold text-tangerine" data-id="element-25" data-mp="1martznsoqa3j">€0</span> nel
            tuo ordine
          </p>
        </div>

        <ol className="mt-10 space-y-4" data-id="element-26" data-mp="1r78tfe5c4avx">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_2px_10px_-6px_rgba(22,56,111,0.25)]" data-id="element-27" data-mp="3icvan7ku2bzt" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tangerine font-display text-sm font-bold text-white" data-id="element-28" data-mp="3r5givtqu90ae">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-16 w-12 shrink-0 rounded-md object-cover shadow-[0_2px_8px_-4px_rgba(22,56,111,0.4)]" data-id="element-29" data-mp="2zgdd29jazhvn" />
              <div data-id="element-30" data-mp="38htomklutq1g">
                <h3 className="font-display text-sm font-bold leading-snug text-navy" data-id="element-31" data-mp="38e5sresxsrjk">
                  {bonus.title}{' '}
                  <span className="font-sans text-[11px] font-bold uppercase tracking-wide text-teal" data-id="element-32" data-mp="nq1dx6xbhgw4">
                    (Valore {bonus.value})
                  </span>
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy/60" data-id="element-33" data-mp="3ciwryrwu9nk7">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}